exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-image-display .fmcy-image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n  margin: auto; }\n\n.fmcy-image-display .fmcy-large-image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n  position: absolute;\n  margin: auto;\n  left: 10px;\n  right: 10px;\n  top: 10px;\n  bottom: 10px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/product-tile/image-display/image-display.scss
 ** module id = 81
 ** module chunks = 1 2 3 4 5 6 7 9 10 11 13 14 15 16 17 22 25 26 29 32 38 49 67 79 117
 **/